import ButtonSelector from '../../Secondary/ButtonSelector';
import {ReactComponent as SearchIcon} from "assets/icons/search.svg";
import useWindowDimensions from 'helpers/screen';
import './style.scss'

const AssetsTop = ({title, searchSettings, setSearchSettings, filters = null, actionTitle=null, status=null}) => {

  const {width} = useWindowDimensions();
  return <div className="assetsTop">
    <div className="side">
      <div className='left'>
        <p className="title">
          {title}
        </p>
        {actionTitle &&
          <div className='actionButton'>
            {actionTitle}
          </div>
        }
        <p className='showHide disable-select' onClick={ (e) => {setSearchSettings({...searchSettings, showLowValueAssets: 1-searchSettings.showLowValueAssets})}}>
          {
            searchSettings.showLowValueAssets ? 
            "Show Low-Value Assets" 
            : 
            "Hide Low-Value Assets"
          }
        </p>
        <p className='showHide disable-select' onClick={(e) => {setSearchSettings({...searchSettings, showZeroBalances: 1-searchSettings.showZeroBalances})}}>
          {
            searchSettings.showZeroBalances ? "Show 0 Balances" : "Hide 0 Balances"
          }
        </p>
      </div>
      {filters && <ButtonSelector items={filters} selected={0}/>}
    </div>
    {status ? 
    <p className='status'>{status}</p>
    :
    <div className="searchBar">
      <SearchIcon stroke="var(--gray500)"/>
      <input
        className="search"
        placeholder={ width <= 900 ? "Search":"Search by name, symbol or address"}
        onChange={(e) => setSearchSettings({...searchSettings, searchValue: e.target.value})}
      />
    </div>
    }
  </div>
}

export default AssetsTop;